import {
  ADD_FORM_HAS_FAILED_ENDPOINTS,
  CLEAR_FAILED_ENDPOINTS_LIST,
} from '../actions/ErrorActions';

const initialState = {
  failedEndpointsList: {},
};

const appConfig = (state = initialState, action) => {
  switch (action.type) {
    case ADD_FORM_HAS_FAILED_ENDPOINTS:
      return {
        ...state,
        failedEndpointsList: {
          ...state.failedEndpointsList,
          [action.payload.storeKey]: true,
        },
      };
    case CLEAR_FAILED_ENDPOINTS_LIST:
      return { ...state, failedEndpointsList: {} };
    default:
      return state;
  }
};

export default appConfig;
